var activityTypes = [
    { "label": "فروشنده خرد", value: 0 },
    { "label": "فروشنده عمده (پخش)", value: 1 },
];

export default activityTypes;
